import { Component, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';

import { IndividualService } from '../services/individual.service';
import { DataTransferService } from '../services/data-transfer.service';

@Component({
    selector: 'app-individual-maintenance',
    templateUrl: './individual-maintenance.component.html',
    styleUrls: ['./individual-maintenance.component.scss']
})
export class IndividualMaintenanceComponent implements OnInit {
    dataSource = new MatTableDataSource<any>();
    displayedColumns: string[] = ['FULLNAME'];
    loading = false;
    filterText: any;
    indName: any;
    filteredOrgList: any[] = [];
    orgSearchText: string = '';

    @ViewChild(MatSort)
    set matSort(sort: MatSort) {
        this.dataSource.sort = sort;
    }

    constructor(
        public individualService: IndividualService,
        private router: Router,
        private route: ActivatedRoute,
        private dataTransfer: DataTransferService
    ) { }

    ngOnInit() {
        // this disables the utility program sponsor select at the top of the page
        this.dataTransfer.myMethod(true);
        // search results are kept moving between this page and detail but we want 
        // to clear them if coming in new from the setup menu
        const toggle = this.route.snapshot.paramMap.get('toggle');
        if (toggle === '0') {
            this.refresh();
            this.loadInitialTableData();
        } else {
            this.getOrganizationList();
            this.dataSource.data = this.individualService.indvList;
            if (this.individualService.indvList.length === 0) {
                this.loadInitialTableData();
            }
        }

        this.dataSource.filterPredicate =
        (data: any, filtersJson: string) => {
            const matchFilter: boolean[] = [];
            const filters = JSON.parse(filtersJson);

            filters.forEach((filter: any) => {
                const val = data[filter.id] === null ? '' : data[filter.id];
                matchFilter.push(val.toLowerCase().includes(filter.value.toLowerCase()));
            });
            return matchFilter.every(Boolean);
        };

        this.dataSource.sortingDataAccessor = (item: any, property: string) => {
            const value = item?.[property];
            return value === null || value === undefined ? '' : value.toString().toLowerCase();
        };
    }

    onOrgDropdownOpen() {
        this.orgSearchText = '';
        this.filterOrganizations();
    }

    filterOrganizations() {
        if (!this.individualService.orgList) {
            return;
        }

        if (!this.orgSearchText) {
            this.filteredOrgList = this.individualService.orgList.slice();
            return;
        }

        const search = this.orgSearchText.toLowerCase();
        this.filteredOrgList = this.individualService.orgList.filter((org: any) =>
            org?.DESCRIPTION?.toLowerCase().includes(search)
        );
    }

    refresh() {
        this.indName = '';
        this.individualService.selectedOrg = undefined;
        this.individualService.orgList = [];
        this.individualService.indvList = [];
        this.dataSource.data = this.individualService.indvList;

        this.filterText = null;
        this.dataSource.filter = this.filterText;
        this.getOrganizationList();
    }

    getOrganizationList() {
        if (this.individualService.selectedOrg !== undefined && this.individualService.orgList.length > 0) {
            this.filteredOrgList = this.individualService.orgList.slice();
            this.syncSelectedOrganizationFromList(this.individualService.orgList);
            return;
        }

        this.loading = true;
        this.individualService.getOrganizationList().subscribe((data: any) => {
            this.individualService.orgList = data;
            this.filteredOrgList = data;
            this.syncSelectedOrganizationFromList(data);
            this.loading = false;
        });
    }

    compareOrganizations(org1: any, org2: any): boolean {
        if (!org1 && !org2) {
            return true;
        }

        if (!org1 || !org2) {
            return false;
        }

        return org1.VALUE === org2.VALUE;
    }

    private syncSelectedOrganizationFromList(orgList: any[]): void {
        if (!this.individualService.selectedOrg) {
            return;
        }

        const selectedOrgCode = this.individualService.selectedOrg.VALUE;
        const matchingOrg = (orgList || []).find((org: any) => org?.VALUE === selectedOrgCode);
        if (matchingOrg) {
            this.individualService.selectedOrg = matchingOrg;
        }
    }

    doSearch() {
        this.loading = true;
        let val = '';
        const searchText = (this.indName || '').toString().trim();
        if (this.individualService.selectedOrg !== undefined){
            val = this.individualService.selectedOrg.VALUE;
        }
        this.individualService.indName = this.indName;
        this.individualService.getIndividualsForOrganization(val, this.indName).subscribe((data: any) => {
            this.individualService.indvList = this.filterByNameOrOrganization(data, searchText) as any;
            this.dataSource.data = this.individualService.indvList;
            this.loading = false;
        }, err => {
            this.loading = false;
        });
    }

    isNewDisabled(): boolean {
        return this.individualService.selectedOrg === undefined;
    }

    private filterByNameOrOrganization(rows: any[], searchText: string): any[] {
        if (!searchText) {
            return rows || [];
        }

        const normalized = searchText.toLowerCase();
        const organizations = (this.individualService.orgList || []) as any[];
        return (rows || []).filter((row: any) => {
            const fullName = (row?.FULLNAME || '').toString().toLowerCase();
            const orgCode = (row?.ORGANIZATION_CD || '').toString();
            const org = organizations.find((o: any) => o?.VALUE === orgCode);
            const orgDescription = (org?.DESCRIPTION || '').toString().toLowerCase();

            return fullName.includes(normalized) || orgDescription.includes(normalized);
        });
    }

    private loadInitialTableData() {
        this.loading = true;
        this.individualService.getIndividualsForOrganization('', '').subscribe((data: any) => {
            this.individualService.indvList = data;
            this.dataSource.data = this.individualService.indvList;
            this.loading = false;
        }, err => {
            this.loading = false;
        });
    }

    handleClick(row: any) {
        this.loading = true;
        this.individualService.getDetail(row.ORGANIZATION_CD, row.PERSONCOMPANY_ID).subscribe(data => {
            // console.log("data: " + JSON.stringify(data,null, 2));
            this.individualService.indDetail = data;

            console.log("***");
            console.log( this.individualService.indDetail );

            this.individualService.editMode = true;
            this.loading = false;

            const enableControls = row.WAREHOUSE_ID?.length > 0 ? 'DISABLE' : 'ENABLE';
            this.router.navigate(['/individualDetail', enableControls]);
        });
    }

    applyFilter(filterValue: string) {

       
        const tableFilters = [];
        tableFilters.push({
            id: 'FULLNAME',
            value: filterValue
        });

        
        this.dataSource.filter = JSON.stringify(tableFilters);
    }

    newIndividual() {
        this.loading = true;
        const selectedOrgCode = this.individualService.selectedOrg?.VALUE || '';
        const selectedOrgDescription = this.individualService.selectedOrg?.DESCRIPTION || '';

        this.individualService.newDetail(selectedOrgCode).subscribe(data => {
            this.individualService.indDetail = data;
            this.individualService.indDetail.IndividualTab.Individual.FULLNAME = '';
            this.individualService.indDetail.IndividualTab.Individual.SELECTEDORGCODE = selectedOrgCode;
            this.individualService.indDetail.IndividualTab.Individual.SELECTEDORGDESCRIPTION = selectedOrgDescription;

            if (this.individualService.indDetail.IndividualTab.Email === undefined || this.individualService.indDetail.IndividualTab.Email == null) {
                this.individualService.indDetail.IndividualTab.Email = [];
            }
            if (this.individualService.indDetail.IndividualTab.Address === undefined || this.individualService.indDetail.IndividualTab.Address == null) {
                this.individualService.indDetail.IndividualTab.Address = [];
            }
            if (this.individualService.indDetail.DailyHoursTab.DailyHours === undefined || this.individualService.indDetail.DailyHoursTab.DailyHours == null) {
                this.individualService.indDetail.DailyHoursTab.DailyHours = [];
            }
            if (this.individualService.indDetail.GridsTab.Grids === undefined || this.individualService.indDetail.GridsTab.Grids == null) {
                this.individualService.indDetail.GridsTab.Grids = [];
            }
            if (this.individualService.indDetail.RolesTab.Roles === undefined || this.individualService.indDetail.RolesTab.Roles == null) {
                this.individualService.indDetail.RolesTab.Roles = [];
            }
            if (this.individualService.indDetail.IndividualTab.Phone === undefined || this.individualService.indDetail.IndividualTab.Phone == null) {
                this.individualService.indDetail.IndividualTab.Phone = [];
            }
            if (this.individualService.indDetail.BucketSchedulingTab.BucketScheduling === undefined || this.individualService.indDetail.BucketSchedulingTab.BucketScheduling == null) {
                this.individualService.indDetail.BucketSchedulingTab.BucketScheduling = [];
            }

            this.individualService.editMode = false;
            
            this.loading = false;
            this.router.navigate(['/individualDetail', 'ENABLE']);            
        });
    }
}
